import { createSlice } from '@reduxjs/toolkit';

const datasetsSlice = createSlice({
    name: 'datasets',
    initialState: { selectedDataset: null, userDatasets: null },

    reducers: {
        setSelectedDataset: (state, action) => {
            //add selected document to state
            state.selectedDataset = action.payload;
        },
        clearSelectedDataset: (state) => {
            state.selectedDataset = null;
        },
        setUserDatasets: (state, action) => {
            state.userDatasets = action.payload;
        },
        clearUserDatasets: (state) => {
            state.userDatasets = []
        },
    },
});

export const {
    setSelectedDataset,
    clearSelectedDataset,
    setUserDatasets,
    clearUserDatasets,
} = datasetsSlice.actions;
export default datasetsSlice.reducer;
